(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-bag-style-browser"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.styleReady) return;
    root.dataset.styleReady = 'true';
    const rail = root.querySelector('[data-style-rail]');
    const cards = [...root.querySelectorAll('[data-style-card]')];
    const tabs = [...root.querySelectorAll('[data-style-tab]')];
    const prev = root.querySelector('[data-style-prev]');
    const next = root.querySelector('[data-style-next]');
    const position = root.querySelector('[data-style-position]');
    const reduce = matchMedia('(prefers-reduced-motion:reduce)');
    if (!rail || !cards.length) return;
    let active = -1, frame = 0, wheelTimer, selected = null;
    const offset = card => card.offsetLeft - cards[0].offsetLeft;
    const go = index => rail.scrollTo({ left: offset(cards[Math.max(0, Math.min(cards.length - 1, index))]), behavior: reduce.matches ? 'auto' : 'smooth' });
    function update() {
      frame = 0;
      let nearest = 0;
      cards.forEach((card, i) => { if (Math.abs(offset(card) - rail.scrollLeft) < Math.abs(offset(cards[nearest]) - rail.scrollLeft)) nearest = i; });
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      if (selected !== null) nearest = selected;
      if (active !== nearest) {
        active = nearest;
        tabs.forEach((tab, i) => { tab.classList.toggle('is-active', i === active); tab.setAttribute('aria-pressed', String(i === active)); });
        position.textContent = `${String(active + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      }
    }
    tabs.forEach((tab, i) => tab.addEventListener('click', () => { selected = i; go(i); update(); }));
    const step = direction => { selected = null; rail.scrollBy({ left: direction * (cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap)), behavior: reduce.matches ? 'auto' : 'smooth' }); };
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    rail.addEventListener('touchstart', () => { selected = null; }, { passive: true });
    rail.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    rail.addEventListener('keydown', event => {
      if (event.target !== rail) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(active + (event.key === 'ArrowRight' ? 1 : -1)); }
    });
    rail.addEventListener('wheel', event => {
      if (root.dataset.wheel !== 'true' || !matchMedia('(hover:hover) and (min-width:750px)').matches || event.ctrlKey || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;
      const max = rail.scrollWidth - rail.clientWidth;
      const delta = event.deltaY * (event.deltaMode === 1 ? 24 : event.deltaMode === 2 ? rail.clientWidth : 1);
      if ((delta > 0 && rail.scrollLeft >= max - 2) || (delta < 0 && rail.scrollLeft <= 2)) { event.preventDefault(); window.scrollBy({ top: delta, behavior: 'instant' }); return; }
      event.preventDefault(); selected = null; rail.classList.add('is-wheel'); rail.scrollLeft = Math.max(0, Math.min(max, rail.scrollLeft + delta));
      clearTimeout(wheelTimer); wheelTimer = setTimeout(() => rail.classList.remove('is-wheel'), 180);
    }, { passive: false });
    cards.forEach(card => {
      const video = card.querySelector('[data-style-video]');
      if (!video) return;
      const stop = () => { video.pause(); card.classList.remove('is-playing'); };
      card.addEventListener('mouseenter', () => {
        if (reduce.matches || !matchMedia('(hover:hover)').matches) return;
        if (!video.src) { video.src = video.dataset.styleVideo; video.load(); }
        video.muted = true; video.play().then(() => card.classList.add('is-playing')).catch(stop);
      });
      card.addEventListener('mouseleave', stop);
      new IntersectionObserver(entries => { if (!entries[0].isIntersecting) stop(); }).observe(card);
      video.addEventListener('error', stop);
    });
    root.addEventListener('shopify:block:select', event => { const index = cards.indexOf(event.target.closest('[data-style-card]')); if (index >= 0) go(index); });
    addEventListener('resize', update, { passive: true });
    update();
  }
  const boot = scope => scope.querySelectorAll('[data-dd-styles]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-collection-film"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = scope => {
    scope.querySelectorAll('[data-dd-film]').forEach(root => {
      if (root.dataset.filmReady) return;
      const video = root.querySelector('video');
      if (!video) return;
      root.dataset.filmReady = 'true';
      video.setAttribute('playsinline', '');
      video.muted = true;
      const sound = root.querySelector('[data-film-sound]');
      const syncSound = () => { if (sound) { const audible = !video.muted && video.volume > 0; sound.textContent = audible ? sound.dataset.mute : sound.dataset.unmute; sound.setAttribute('aria-pressed', String(audible)); } };
      if (sound) sound.addEventListener('click', () => {
        if (video.muted || video.volume === 0) { video.muted = false; video.volume = 1; video.play().catch(() => {}); }
        else video.muted = true;
        syncSound();
      });
      video.addEventListener('volumechange', syncSound);
      syncSound();
      let visible = false, pausedByVisitor = false, automaticPause = false;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const allowed = () => root.dataset.autoplay === 'true' && !reduced.matches && !navigator.connection?.saveData;
      const play = () => { if (visible && !document.hidden && !pausedByVisitor && allowed()) video.play().catch(() => {}); };
      const pause = () => { if (!video.paused) { automaticPause = true; video.pause(); } };
      video.addEventListener('pause', () => { if (automaticPause) automaticPause = false; else if (!video.ended) pausedByVisitor = true; });
      video.addEventListener('play', () => { pausedByVisitor = false; });
      new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) { video.preload = 'metadata'; play(); } else pause();
      }, { threshold: .35 }).observe(video);
      document.addEventListener('visibilitychange', () => { if (document.hidden) pause(); else play(); });
      reduced.addEventListener('change', () => { if (reduced.matches) pause(); else play(); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-collection-master"] && !Shopify.designMode) return;
  try {
    
  (function initDdMasterCollection(){
    var root = document.querySelector('[data-dd-master-collection]');
    if (!root) return;

    // Tile variant pills · hover-preview / click-commit background swap
    root.querySelectorAll('.dd-mc-tile').forEach(function(tile){
      var dots = tile.querySelectorAll('.dd-mc-tile__dot');
      var imgEl = tile.querySelector('.dd-mc-tile__img');
      if (!imgEl || dots.length === 0) return;
      var defaultBg = imgEl.style.backgroundImage;
      var activeBg = defaultBg;

      dots.forEach(function(dot){
        dot.addEventListener('mouseenter', function(){
          var url = dot.getAttribute('data-variant-img');
          if (url) imgEl.style.backgroundImage = "url('" + url + "')";
        });
        dot.addEventListener('mouseleave', function(){
          imgEl.style.backgroundImage = activeBg;
        });
        dot.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          dots.forEach(function(d){ d.classList.remove('is-active'); });
          dot.classList.add('is-active');
          var url = dot.getAttribute('data-variant-img');
          if (url) {
            activeBg = "url('" + url + "')";
            imgEl.style.backgroundImage = activeBg;
          }
        });
      });
    });

    // Currency dropdown · toggle · select fires form submit for real Shopify localization change
    var wrap = root.querySelector('.dd-mc-currency');
    if (!wrap) return;
    var btn = wrap.querySelector('.dd-mc-currency__button');
    var codeEl = btn.querySelector('[data-currency-code]');
    var items = wrap.querySelectorAll('.dd-mc-currency__item');
    var form = root.querySelector('#dd-mc-currency-form');
    var countryInput = root.querySelector('[data-country-input]');

    function setOpen(open){
      wrap.setAttribute('data-open', open ? 'true' : 'false');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      setOpen(wrap.getAttribute('data-open') !== 'true');
    });
    items.forEach(function(item){
      item.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        items.forEach(function(i){
          i.classList.remove('is-active');
          i.setAttribute('aria-selected', 'false');
        });
        item.classList.add('is-active');
        item.setAttribute('aria-selected', 'true');
        codeEl.textContent = item.getAttribute('data-code');
        if (countryInput) countryInput.value = item.getAttribute('data-country') || '';
        setOpen(false);
        if (form) form.submit();
      });
    });
    document.addEventListener('click', function(){ setOpen(false); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') setOpen(false); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-nkari-set"] && !Shopify.designMode) return;
  try {
    
  /* IRON GATE IG-HOMEPAGE-NKARI-SET */
  (function () {
    var roots = document.querySelectorAll('[data-dd-nkari-set]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var slots = root.querySelectorAll('.dd-nks__slot');
      var reserveBtn = root.querySelector('[data-dd-nks-reserve]');
      var errorEl = root.querySelector('[data-dd-nks-error]');

      /* Swap toggle + option click per slot */
      slots.forEach(function (slot) {
        var toggle = slot.querySelector('[data-swap-toggle]');
        var panel = slot.querySelector('[data-swap-panel]');
        var opts = slot.querySelectorAll('[data-swap-opt]');
        var img = slot.querySelector('[data-slot-img]');
        var label = slot.querySelector('[data-slot-label]');

        if (toggle && panel) {
          toggle.addEventListener('click', function () {
            var open = panel.hasAttribute('hidden') ? false : true;
            if (open) {
              panel.setAttribute('hidden', '');
              toggle.setAttribute('aria-expanded', 'false');
            } else {
              panel.removeAttribute('hidden');
              toggle.setAttribute('aria-expanded', 'true');
            }
          });
        }

        opts.forEach(function (opt) {
          opt.addEventListener('click', function () {
            var vId = opt.getAttribute('data-variant-id') || '';
            var handle = opt.getAttribute('data-handle') || '';
            var lbl = opt.getAttribute('data-label') || '';
            var imgSrc = opt.getAttribute('data-img') || '';

            slot.setAttribute('data-current-variant-id', vId);
            slot.setAttribute('data-current-handle', handle);
            if (label && lbl) label.textContent = lbl;

            if (img && imgSrc) {
              img.classList.add('is-swapping');
              window.setTimeout(function () {
                if (img.tagName === 'IMG') {
                  img.src = imgSrc;
                  img.alt = lbl;
                } else {
                  /* Replace placeholder div with img */
                  var newImg = document.createElement('img');
                  newImg.className = 'dd-nks__img';
                  newImg.setAttribute('data-slot-img', '');
                  newImg.src = imgSrc;
                  newImg.alt = lbl;
                  newImg.loading = 'lazy';
                  newImg.decoding = 'async';
                  img.parentNode.replaceChild(newImg, img);
                  img = newImg;
                }
                img.classList.remove('is-swapping');
              }, 220);
            }

            slot.querySelectorAll('[data-swap-opt]').forEach(function (o) {
              o.classList.toggle('is-current', o === opt);
              o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
            });
          });
        });
      });

      /* IRON GATE IG-BUNDLE-COLOUR-VARIANT · section-level colour pills.
         When a pill is clicked, apply its per-slot variant/handle/image to all
         three slots in one motion. "mix" mode restores per-slot control. */
      var pills = root.querySelectorAll('[data-dd-colour-pill]');

      function applySlot(slot, vid, handle, imgSrc, lbl) {
        if (!slot) return;
        if (vid) slot.setAttribute('data-current-variant-id', vid);
        if (handle) slot.setAttribute('data-current-handle', handle);
        var lblEl = slot.querySelector('[data-slot-label]');
        if (lblEl && lbl) lblEl.textContent = lbl;
        var img = slot.querySelector('[data-slot-img]');
        if (img && imgSrc) {
          img.classList.add('is-swapping');
          window.setTimeout(function () {
            if (img.tagName === 'IMG') {
              img.src = imgSrc; img.alt = lbl || '';
            } else {
              var newImg = document.createElement('img');
              newImg.className = 'dd-nks__img';
              newImg.setAttribute('data-slot-img', '');
              newImg.src = imgSrc; newImg.alt = lbl || '';
              newImg.loading = 'lazy'; newImg.decoding = 'async';
              img.parentNode.replaceChild(newImg, img);
              img = newImg;
            }
            img.classList.remove('is-swapping');
          }, 220);
        }
        /* Mark matching per-slot option as current where possible. */
        var opts = slot.querySelectorAll('[data-swap-opt]');
        opts.forEach(function (o) {
          var match = String(o.getAttribute('data-variant-id')) === String(vid);
          o.classList.toggle('is-current', match);
          o.setAttribute('aria-selected', match ? 'true' : 'false');
        });
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var mode = pill.getAttribute('data-mode-key') || 'mix';
          root.setAttribute('data-active-mode', mode);

          pills.forEach(function (p) {
            var on = p === pill;
            p.classList.toggle('is-current', on);
            p.setAttribute('aria-pressed', on ? 'true' : 'false');
          });

          if (mode === 'mix') {
            /* Do NOT change slot images — keep whatever the user has picked. */
            return;
          }

          [1, 2, 3].forEach(function (n) {
            var slot = root.querySelector('.dd-nks__slot[data-slot-index="' + n + '"]');
            var vid = (pill.getAttribute('data-s' + n + '-variant') || '').trim();
            var handle = (pill.getAttribute('data-s' + n + '-handle') || '').trim();
            var img = (pill.getAttribute('data-s' + n + '-img') || '').trim();
            var lbl = (pill.getAttribute('data-s' + n + '-label') || '').trim();
            if (!vid && !handle && !img) return;
            applySlot(slot, vid, handle, img, lbl);
          });
        });
      });

      /* Seed active mode from any pre-marked default pill. */
      var initialPill = root.querySelector('[data-dd-colour-pill].is-current');
      if (initialPill) {
        root.setAttribute('data-active-mode', initialPill.getAttribute('data-mode-key') || 'mix');
      } else {
        root.setAttribute('data-active-mode', 'mix');
      }

      /* Reserve — POST /cart/add.js with 3 slot variants + optional deposit,
         grouped by properties[_bundle_id]. */
      if (reserveBtn) {
        reserveBtn.addEventListener('click', function () {
          if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
          var bundleId = 'nkari-set-' + Date.now();
          var depositId = (root.getAttribute('data-deposit-variant-id') || '').trim();
          var items = [];

          root.querySelectorAll('.dd-nks__slot').forEach(function (slot) {
            var vid = (slot.getAttribute('data-current-variant-id') || '').trim();
            if (!vid) return;
            items.push({
              id: Number(vid),
              quantity: 1,
              properties: {
                _bundle_id: bundleId,
                _bundle_slot: slot.getAttribute('data-slot-index'),
                _bundle_kind: 'nkari-travel-set'
              }
            });
          });

          if (depositId && /^\d+$/.test(depositId)) {
            items.push({
              id: Number(depositId),
              quantity: 1,
              properties: {
                _bundle_id: bundleId,
                _bundle_slot: 'deposit',
                _bundle_kind: 'nkari-travel-set'
              }
            });
          } else {
            /* stub write-path: deposit product not yet configured — proceed
               with the 3-item bundle so the UI is verifiable end-to-end. */
            /* eslint-disable no-console */
            if (window && window.console) {
              window.console.warn('[dd-nkari-set] deposit_variant_id not configured — skipping deposit line item. Set section.settings.deposit_variant_id.');
            }
          }

          if (!items.length) {
            if (errorEl) {
              errorEl.textContent = root.getAttribute('data-no-variants-text') || 'No variants selected.';
              errorEl.hidden = false;
            }
            return;
          }

          reserveBtn.disabled = true;
          var originalText = reserveBtn.querySelector('.dd-nks__cta-text');
          var originalCopy = originalText ? originalText.textContent : '';
          if (originalText) originalText.textContent = root.getAttribute('data-reserving-text') || 'Reserving…';

          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) {
              if (!res.ok) {
                return res.json().then(function (err) { throw err; }, function () { throw new Error('Cart add failed (' + res.status + ')'); });
              }
              return res.json();
            })
            .then(function () { window.location.href = '/cart'; })
            .catch(function (err) {
              reserveBtn.disabled = false;
              if (originalText) originalText.textContent = originalCopy;
              if (errorEl) {
                errorEl.textContent = (err && err.description) || (err && err.message) || root.getAttribute('data-reserve-error-text') || 'Could not reserve. Please try again.';
                errorEl.hidden = false;
              }
              /* eslint-disable no-console */
              if (window && window.console) window.console.error('[dd-nkari-set] reserve failed', err);
            });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
